import { faSmile } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getBenef, setBenef } from "../../../Store/storages/BeneficiarioStorage";
import { StepIngressarAtendProps } from "../../../interfaces/props/SaudeOnline/IngressarNoAtendimento/StepIngressarAtendProps";
import { getHabilitaValidacaoTelemedicina } from "../../../services/IngressarAtendimentoService";
import CameraAcess from "./CameraAcess";
import HeaderTelessaude from "./HeaderTelessaude";
import ModalCameraAccess from "./ModalCameraAccess";
import RegisterModal from "./RegisterModal";
import ValidateCameraCapture from "./ValidateCameraCapture";
import WarningModal from "./WarningModal";
import { sxButtonTelessaudeAtendValidarBiometria, sxTypographyValidateBiometricsDescription, sxTypographyValidateBiometricsTitle } from "./sxProps";

const StepValidarBiometriaFacial: React.FC<StepIngressarAtendProps> = ({ ...props }) => {

  const [showModalCameraAccess, setShowModalCameraAccess] = useState<boolean>(false);
  const [showRegistrationModal, setShowRegistrationModal] = useState<boolean>(false);
  const [showWarningModal, setShowWarningModal] = useState<boolean>(false);
  const [isCapturing, setIsCapturing] = useState<boolean>(false);
  const [allowCamera, setAllowCamera] = useState<boolean>(false);
  const [register, setRegister] = useState<boolean>(false);
  const [hasRegistration, setHasRegistration] = useState<boolean>(false);
  const { nextStep } = { ...props };

  useEffect(() => {
    checkBiometry();
  }, []);

  const getBiometryEnabled = async () => {
    let response = await getHabilitaValidacaoTelemedicina();
    let enabled: boolean = (response === "S");
    return enabled;
  }

  const checkBiometry = async () => {
    let enabled = await getBiometryEnabled();
    if (!enabled) {
      nextStep();
    } else {
      let benef = getBenef(); //TODO LÓGICA PARA VALIDAR SE
      
      if(benef?.indBioFacial === 'S'){
        setHasRegistration(true)
      } 
    }
  };

  const handleShowModalCameraAccess = () => {
    setShowModalCameraAccess(showModalCameraAccess => !showModalCameraAccess);
  }

  const handleAllowCamera = (allow: boolean) => {
    setAllowCamera(allow);
    if(!hasRegistration){
      setShowRegistrationModal(true);
    }
    else {
      setIsCapturing(allow);
    }
  }

  const askForCameraPermission = () => {
    setShowModalCameraAccess(true);
  }

  const handleValidation = () => {
    let benef = getBenef();
    setRegister(false);
    if(benef?.indBioFacial !== undefined){
      benef.indBioFacial = 'S';
      setBenef(benef)
    }
    setIsCapturing(true);
  }

  const handleRegistration = () => {
    setRegister(true);
    setShowRegistrationModal(false)
  }

  const handleContinue = () => {
    
    setShowWarningModal(true);
  }

  const handleContinueModal = () => {
    nextStep();
    setShowRegistrationModal(false);
  }

  const handleTryAgain = () => {
    setShowWarningModal(false)
  } 

  const handleCloseWarningModal = () => {
    setShowWarningModal(false)
  }

  const handleCloseModal = () => {
    setShowRegistrationModal(false)
  }

  const facialBiometryInfos = (
    <>
      {!register &&
        <>
          <HeaderTelessaude />
          <div className='info-container-holder'>
            <div className='validate-facial-biometrics-info-container'>
              <div className='advice-validate-facial-biometrics'>
                <div className='icon-circle-container-50px'>
                  <div className='circle-background' />
                  <FontAwesomeIcon icon={faSmile} className='fa-smile-ingressar-atendimento' />
                </div>
                <Typography sx={sxTypographyValidateBiometricsTitle}>Antes de prosseguir para o atendimento, precisamos validar a sua biometria facial</Typography>
                <Typography sx={sxTypographyValidateBiometricsDescription}>Este procedimento se deve às nossas ações de prevenção de fraudes. Para garantir sua segurança, este atendimento poderá ser auditado caso a biometria facial não seja validada.</Typography>
              </div>
              <Button
                type='button'
                variant='contained'
                sx={sxButtonTelessaudeAtendValidarBiometria}
                onClick={askForCameraPermission}
              >
                <Typography className='text-nowrap'>VALIDAR BIOMETRIA FACIAL</Typography>
              </Button>
            </div>
          </div>
        </>
      }
    </>
  );
  return (
    <>
      <div className={`${isCapturing ? 'telessaude-space-between-content' : 'ingressar-atendimento-gap-content'}`}>
        {isCapturing && allowCamera ? <ValidateCameraCapture nextStep={nextStep}/> : facialBiometryInfos}
        {register && allowCamera && !isCapturing && <CameraAcess handleValidation={handleValidation} handleContinue={handleContinue}/>}
      </div>
      <ModalCameraAccess showModal={showModalCameraAccess} handleShowModal={handleShowModalCameraAccess} handleAllowCamera={handleAllowCamera} />
      <RegisterModal open={showRegistrationModal} handleRegistration={handleRegistration} handleCloseModal={handleCloseModal}/>
      <WarningModal open={showWarningModal} handleTryAgain={handleTryAgain} handleContinueModal={handleContinueModal} handleCloseWarningModal={handleCloseWarningModal}/>
    </>
  )
}

export default StepValidarBiometriaFacial;